import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://vmlcwhavjceevevnenqw.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZtbGN3aGF2amNlZXZldm5lbnF3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjMxNDU0NjYsImV4cCI6MjA3ODcyMTQ2Nn0.UFjEeTOti01hNfKhyC77Iwh3p7ICmBOvBLkqhbTX18c';

if (!supabaseUrl || !supabaseKey) {
    throw new Error('Missing Supabase URL or Anon Key');
}

export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  }
});